module.exports = __webpack_public_path__ + "media/images/bg/flag-0719d95a579a029526ae74c5784d92bb.png";